import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ParkingPass} from '../../../types/models';
import {AuthenticationService} from '../../../services/authentication.service';
import {ParkingPassService} from '../../../services/parking-pass.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'parking-pass-view',
    templateUrl: './parking-pass-view.component.html',
    styleUrls: ['./parking-pass-view.component.scss']
})
export class ParkingPassViewComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: ParkingPass = new ParkingPass();
    disabledSubmit = false;
    date: string = (new Date).toISOString();

    constructor(
        public api: ApiClientService,
        public parkingPassService: ParkingPassService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        this.parkingPassService.isViewModalShow = false;
        this.parkingPassService.parkingPassInParkingPassModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-view/parking-pass-view.component.ts